export enum SSEName {
	EMPLOYEE_DOCUMENTS_UPDATED = 'EMPLOYEE_DOCUMENTS_UPDATED',
	EMPLOYEE_CONTRACTS_UPDATED = 'EMPLOYEE_CONTRACTS_UPDATED',
	// not implemented
	// EMPLOYEE_SF_EVENTS_UPDATED = 'EMPLOYEE_SF_EVENTS_UPDATED',
}
